'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _watchAppNotifier = require('common/components/mixins/watch-app-notifier');

var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// In-app left side menu
var AppLeftMenu = _react2['default'].createClass({
    displayName: 'AppLeftMenu',


    mixins: [_watchAppNotifier2['default']],

    propTypes: {
        'siteCode': _react2['default'].PropTypes.string.isRequired, // S or F
        'pageSize': _react2['default'].PropTypes.number, // List size
        'searchBackend': _react2['default'].PropTypes.string, // Type of search backend to use
        'activeItemId': _react2['default'].PropTypes.string, // Menu item currently active
        'hasTeamFilter': _react2['default'].PropTypes.bool, // Whether the user can view all team docs
        'hasCompletedFilter': _react2['default'].PropTypes.bool, // Whether the completed filter is visible currently
        'emailAddress': _react2['default'].PropTypes.string.isRequired, // Email address for the current user
        'faxNumbers': _react2['default'].PropTypes.array, // List of fax numbers
        'name': _react2['default'].PropTypes.string // Name of the user
    },

    FILTERS: {
        'documentsallteam': 'all_team',
        'documentsoutforsignature': 'out_for_signature',
        'documentsawaiting': 'awaiting_my_signature',
        'documentscompleted': 'completed',
        'documentstemplates': 'template',
        'documentstemplatelinks': 'template_link',
        'documentsdrafts': 'draft',
        'documentssent': 'sent',
        'documentsreceived': 'received'
    },

    getInitialState: function getInitialState() {

        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
        var defaultItemId = isHf ? 'sendfax' : 'signdocs';
        var activeItemId = this.props.activeItemId || defaultItemId;

        // Convert filters to section item ref
        for (var k in this.FILTERS) {
            if (this.FILTERS[k] === activeItemId) {
                activeItemId = k;
                break;
            }
        }

        return {
            'activeItemId': activeItemId,
            faxLines: this.props.app.user.getFaxLines()
        };
    },

    componentDidMount: function componentDidMount() {

        var root = $(_reactDom2['default'].findDOMNode(this));
        var self = this;

        $('.m-app-leftmenu--section--title > a, .m-app-leftmenu--section--item > a', root).click(function (evt) {

            if (evt.target.tagName === 'A' || evt.target.parentNode.tagName === 'A') {
                return;
            }

            evt.preventDefault();

            var el = $(this);
            var itemId = el.attr('id');

            if (!itemId) {
                itemId = el.parent().attr('id');
            }

            self.setState({
                'activeItemId': itemId
            });
        });
    },

    getItemClassName: function getItemClassName(sectionName, isItem) {
        var s = 'm-app-leftmenu--section' + (isItem ? '--item' : '');
        if (sectionName === 'signdocs' && $.inArray(this.state.activeItemId, ['signjustme', 'signmeandothers', 'signjustothers']) >= 0 || sectionName === 'templates' && $.inArray(this.state.activeItemId, ['createtemplate', 'createtemplatelink', 'usetemplate', 'usetemplatelink']) >= 0 || sectionName === 'documents' && $.inArray(this.state.activeItemId, Object.keys(this.FILTERS)) >= 0) {
            s += ' is-expanded';
        } else if (this.state.activeItemId === sectionName) {
            s += ' is-active';
        }
        return s;
    },

    makeFilter: function makeFilter(id, label, noDot) {

        var params = ['filter=' + this.FILTERS[id]];
        if (this.props.searchBackend) {
            params.push('search_backend=' + this.props.searchBackend);
        }
        if (this.props.pageSize) {
            params.push('page_size=' + this.props.pageSize);
        }

        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        var url = _hfReactHelper2['default'].urlHelper('home/manage?' + params.join('&'), site);

        var dotImg;
        if (noDot !== true) {
            dotImg = _jsx('img', {
                src: _hfReactHelper2['default'].imgHelper('v2/layout/filters/' + id.replace('documents', '') + '@2x.png')
            });
        }

        return _jsx('div', {
            id: id,
            className: this.getItemClassName(id, true)
        }, void 0, _jsx('span', {
            className: 'm-app-leftmenu--section--item--dot' + (noDot === true ? ' is-blank' : '')
        }, void 0, dotImg), _jsx('a', {
            href: url
        }, void 0, label));
    },

    render: function render() {

        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
        var templates;
        var sendFax;
        var recvFax;
        var getFreePages;
        var signDocs;
        var allTeamDocsFilter;
        var completedFilter;
        var faxNumbers;
        var siteSpecificFilters;

        var meAndOthersParams = 'me=1';

        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        var teamUrl = _hfReactHelper2['default'].urlHelper('home/team', site);
        var createTemplateUrl = _hfReactHelper2['default'].urlHelper('home/createTemplate', site);
        var createLinkUrl = _hfReactHelper2['default'].urlHelper('home/createReusableLink', site);
        var sendFaxUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
        var recvFaxUrl = _hfReactHelper2['default'].urlHelper('home/upgrade', site);
        var freePagesUrl = _hfReactHelper2['default'].urlHelper('account/gettingStarted', site);
        var useTemplateUrl = _hfReactHelper2['default'].urlHelper('home/manage?filter=template', site);
        var useLinkUrl = _hfReactHelper2['default'].urlHelper('home/manage?filter=template_link', site);
        var justMeUrl = _hfReactHelper2['default'].urlHelper('sign', site);
        var meAndOthersUrl = _hfReactHelper2['default'].urlHelper('home/request?' + meAndOthersParams, site);
        var justOthersUrl = _hfReactHelper2['default'].urlHelper('home/request', site);
        var signUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
        var templateUrl = _hfReactHelper2['default'].urlHelper('home/createReusableDocs', site);
        var docsUrl = _hfReactHelper2['default'].urlHelper('home/manage', site);
        var documentsName = 'Documents';

        if (isHf) {

            documentsName = 'Faxes';

            sendFax = _jsx('div', {
                id: 'sendfax',
                className: this.getItemClassName('sendfax')
            }, void 0, _jsx('div', {
                className: 'm-app-leftmenu--section--title'
            }, void 0, _jsx('a', {
                href: sendFaxUrl
            }, void 0, _jsx('span', {}, void 0, 'Send a fax'))));

            if (this.props.showUpgradeButton == true) {
                recvFax = _jsx('div', {
                    id: 'recvfax',
                    className: this.getItemClassName('recvfax')
                }, void 0, _jsx('div', {
                    className: 'm-app-leftmenu--section--title'
                }, void 0, _jsx('a', {
                    href: recvFaxUrl
                }, void 0, _jsx('span', {}, void 0, 'Receive faxes'))));
            } else {
                recvFax = "";
            }

            signDocs = _jsx('div', {
                id: 'signdocs',
                className: this.getItemClassName('signdocs')
            }, void 0, _jsx('div', {
                className: 'm-app-leftmenu--section--title'
            }, void 0, _jsx('a', {
                href: justOthersUrl
            }, void 0, _jsx('span', {}, void 0, 'Sign documents'))));

            getFreePages = _jsx('div', {
                id: 'getfreepages',
                className: 'l-margin-t-50 ' + this.getItemClassName('getfreepages')
            }, void 0, _jsx('div', {
                className: 'm-app-leftmenu--section--title'
            }, void 0, _jsx('a', {
                href: freePagesUrl
            }, void 0, _jsx('span', {}, void 0, 'Get free pages'))));
            if (this.props.hasTeamFilter) {
                allTeamDocsFilter = this.makeFilter('documentsallteam', 'All team faxes');
            }
            siteSpecificFilters = _jsx('div', {
                className: 'm-app-leftmenu--section--items'
            }, void 0, allTeamDocsFilter, this.makeFilter('documentssent', 'Sent'), this.makeFilter('documentsreceived', 'Received'), this.makeFilter('documentsdrafts', 'Drafts'));

            if (this.state.faxLines && this.state.faxLines.length > 0) {

                var numbers = this.state.faxLines.map(function (faxLine) {
                    return _jsx('div', {
                        className: 'm-app-leftmenu--fax-numbers--list--item'
                    }, void 0, faxLine.number);
                });

                var listClasses = (0, _classnames2['default'])({
                    'm-app-leftmenu--fax-numbers--list': true,
                    'is-scrollable': this.state.faxLines.length > 12
                });

                faxNumbers = _jsx('div', {
                    className: 'm-app-leftmenu--fax-numbers'
                }, void 0, _jsx('div', {
                    className: 'm-app-leftmenu--fax-numbers--title'
                }, void 0, this.state.faxLines.length > 1 ? "YOUR FAX NUMBERS" : "YOUR FAX NUMBER"), _jsx('div', {
                    className: listClasses
                }, void 0, numbers));
            }
        } else {

            signDocs = _jsx('div', {
                id: 'signdocs',
                className: this.getItemClassName('signdocs')
            }, void 0, _jsx('div', {
                className: 'm-app-leftmenu--section--title'
            }, void 0, _jsx('a', {
                href: signUrl
            }, void 0, _jsx('span', {}, void 0, 'Sign documents'))), _jsx('div', {
                className: 'm-app-leftmenu--section--items'
            }, void 0, _jsx('div', {
                id: 'signjustme',
                className: this.getItemClassName('signjustme', true)
            }, void 0, _jsx('a', {
                href: justMeUrl
            }, void 0, 'Just me')), _jsx('div', {
                id: 'signmeandothers',
                className: this.getItemClassName('signmeandothers', true)
            }, void 0, _jsx('a', {
                href: meAndOthersUrl
            }, void 0, 'Me & others')), _jsx('div', {
                id: 'signjustothers',
                className: this.getItemClassName('signjustothers', true)
            }, void 0, _jsx('a', {
                href: justOthersUrl
            }, void 0, 'Just others'))));

            templates = _jsx('div', {
                id: 'templates',
                className: this.getItemClassName('templates')
            }, void 0, _jsx('div', {
                className: 'm-app-leftmenu--section--title m-app-leftmenu--templates'
            }, void 0, _jsx('a', {
                href: templateUrl
            }, void 0, _jsx('span', {}, void 0, 'Templates'))), _jsx('div', {
                className: 'm-app-leftmenu--section--items'
            }, void 0, _jsx('div', {
                id: 'createtemplate',
                className: this.getItemClassName('createtemplate', true)
            }, void 0, _jsx('a', {
                href: createTemplateUrl
            }, void 0, 'Create template')), _jsx('div', {
                id: 'createtemplatelink',
                className: this.getItemClassName('createtemplatelink', true)
            }, void 0, _jsx('a', {
                href: createLinkUrl
            }, void 0, 'Create link')), _jsx('div', {
                id: 'usetemplate',
                className: this.getItemClassName('usetemplate', true)
            }, void 0, _jsx('a', {
                href: useTemplateUrl
            }, void 0, 'Use template')), _jsx('div', {
                id: 'usetemplatelink',
                className: this.getItemClassName('usetemplatelink', true)
            }, void 0, _jsx('a', {
                href: useLinkUrl
            }, void 0, 'Use link'))));

            // Removing the Completed filter until this is fully implemented (Chris 1/28/2015)
            // { this.makeFilter('documentscompleted', 'Completed')}
            // ^ goes right after 'Awaiting my signature'
            if (this.props.hasTeamFilter) {
                allTeamDocsFilter = this.makeFilter('documentsallteam', 'All team documents');
            }
            if (this.props.hasCompletedFilter) {
                completedFilter = this.makeFilter('documentscompleted', 'Completed');
            }
            siteSpecificFilters = _jsx('div', {
                className: 'm-app-leftmenu--section--items'
            }, void 0, allTeamDocsFilter, this.makeFilter('documentsoutforsignature', 'Out for signature'), this.makeFilter('documentsawaiting', 'Awaiting my signature'), completedFilter, this.makeFilter('documentstemplates', 'Templates'), this.makeFilter('documentstemplatelinks', 'Template links'), this.makeFilter('documentsdrafts', 'Draft'));
        }

        var res = _jsx('div', {
            className: 'm-app-leftmenu'
        }, void 0, sendFax, recvFax, signDocs, templates, _jsx('div', {
            id: 'documents',
            className: this.getItemClassName('documents')
        }, void 0, _jsx('div', {
            className: 'm-app-leftmenu--section--title m-app-leftmenu--documents'
        }, void 0, _jsx('a', {
            href: docsUrl
        }, void 0, _jsx('span', {}, void 0, documentsName))), _jsx('div', {
            className: 'm-app-leftmenu--section--items'
        }, void 0, siteSpecificFilters)), _jsx('div', {
            id: 'manageteam',
            className: this.getItemClassName('manageteam')
        }, void 0, _jsx('div', {
            className: 'm-app-leftmenu--section--title m-app-leftmenu--team'
        }, void 0, _jsx('a', {
            href: teamUrl
        }, void 0, _jsx('span', {}, void 0, 'Team')))), getFreePages, faxNumbers);

        return res;
    }

});

module.exports = AppLeftMenu;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/sidebar/index.jsx
 ** module id = 709
 ** module chunks = 0
 **/